module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav-bar', {
    attrs: {
      "title": "Load More & No Data"
    }
  }), _vm._v(" "), _c('scroller', {
    ref: "my_scroller",
    attrs: {
      "on-infinite": _vm.infinite
    }
  }, [_c('div', {
    staticStyle: {
      "height": "44px"
    }
  }), _vm._v(" "), _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      staticClass: "row",
      class: {
        'grey-bg': index % 2 == 0
      }
    }, [_vm._v("\n      " + _vm._s(item) + "\n    ")])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fbd2708"}!./~/vue-loader/lib/selector.js?type=template&index=0!./demo/components/LoadMoreAndNoData2.vue
// module id = 46
// module chunks = 0